import { PressedKeys } from './pressed-keys.js';

function isSnappingDisabled(e) {
    return e.ctrlKey || PressedKeys.isPressed('KeyS');
}

export { isSnappingDisabled };
//# sourceMappingURL=snapping.js.map
